<template>
  <div class="sms-contact-chip-container">
    <SmsAvatar class="sms-contact-chip-avatar" :size="avatarSize" :contact="contact" />
    <span class="sms-contact-chip-content">
      {{ contact.displayName }}
    </span>
    <v-btn v-if="!disableClose" icon small @click.stop="$emit('close')">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import SmsAvatar from '@/components/SmsAvatar/SmsAvatar';

export default {
  name: 'SmsChipItem',

  components: { SmsAvatar },

  props: {
    contact: {
      type: Object,
      default: () => {}
    },
    disableClose: {
      type: Boolean,
      default: false
    },
    avatarSize: {
      type: Number,
      default: 28
    }
  }
};
</script>

<style scoped>
.sms-contact-chip-container {
  cursor: pointer;
  max-width: 200px;
  display: grid;
  grid-template-columns: 28px auto 28px;
  background: #0001;
  font-size: 13px;
  border-radius: 14px;
  height: 28px;
  line-height: 28px;
  margin: 4px;
}
.sms-contact-chip-avatar {
  margin-right: 4px;
}
.sms-contact-chip-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
}
</style>
